module.exports = __webpack_public_path__ + "img/main_toplogo.95895d8f.png";